/* Tab 01 */
export { default as img01 } from './maplayer_1_3_1_a1a_a.svg'
export { default as img02 } from './maplayer_1_3_1_a1a_b-01.svg'
export { default as img03 } from './maplayer_1_3_1_a1b_a-01.svg'
export { default as img04 } from './maplayer_1_3_1_a1b_b-01.svg'
export { default as img05a } from './maplayer_1_3_1_a1c-a-01.svg'
export { default as img05b } from './maplayer_1_3_1_a1c-b-01.svg'
export { default as img06a } from './maplayer_1_3_1_a2-a-01.svg'
export { default as img06b } from './maplayer_1_3_1_a2-b-01.svg'
export { default as img07a } from './maplayer_1_3_1_a4-a-01.svg'
export { default as img07b } from './maplayer_1_3_1_a4-b-01.svg'
export { default as img001a } from './maplayer_1_3_1_vop_c13-a-01.svg'
export { default as img001b } from './maplayer_1_3_1_vop_c13-b-01.svg'
export { default as img002a } from './maplayer_1_3_1_vop_c15-a-01.svg'
export { default as img002b } from './maplayer_1_3_1_vop_c15-b.svg'
export { default as img003a } from './maplayer_1_3_1_vop_c16-a-01.svg'
export { default as img003b } from './maplayer_1_3_1_vop_c16-b.svg'
export { default as img004a } from './maplayer_1_3_1_vop_c18-a-01.svg'
export { default as img004b } from './maplayer_1_3_1_vop_c18-b-01.svg'
export { default as img005a } from './svg_1_3_1_VOP_D14_A.svg'
export { default as img005b } from './svg_1_3_1_VOP_D14_B.svg'
export { default as img006a } from './maplayer_1_3_1_vop_d24_d26_d28-a-01.svg'
export { default as img006b } from './maplayer_1_3_1_vop_d24_d26_d28-b-01.svg'
export { default as img007a } from './maplayer_1_3_1_vop_d57-a-01.svg'
export { default as img007b } from './maplayer_1_3_1_vop_d57-b-01.svg'
export { default as img008a } from './maplayer_1_3_1_vop_d95-a-01.svg'
export { default as img008b } from './maplayer_1_3_1_vop_d95-b-01.svg'
export { default as img009a } from './maplayer_1_3_1_vop_e72_e75_e77-a-01.svg'
export { default as img009b } from './maplayer_1_3_1_vop_e72_e75_e77-b-01.svg'
export { default as img010a } from './maplayer_1_3_1_vop_e17_e19-a-01.svg'
export { default as img010b } from './maplayer_1_3_1_vop_e17_e19-b-01.svg'
export { default as img011a } from './maplayer_1_3_1_vop_f08-a-01-01.svg'
export { default as img011b } from './maplayer_1_3_1_vop_f08-b-01.svg'
export { default as img012a } from './maplayer_1_3_1_j_p_apron_p10_p16_normal-a-01.svg'
export { default as img012b } from './maplayer_1_3_1_j_p_apron_p10_p16_normal-b-01.svg'
export { default as img013a } from './maplayer_1_3_1_y_apron-a-01.svg'
export { default as img013b } from './maplayer_1_3_1_y_apron-b-01.svg'

/* Tab 02 */
export { default as img08 } from './maplayer_1_3_2_all-01.svg'
export { default as img09 } from './maplayer_1_3_2_u-01.svg'
export { default as img10 } from './maplayer_1_3_2_j-01.svg'
export { default as img11 } from './maplayer_1_3_2_y-01.svg'
export { default as img12 } from './maplayer_1_3_2_s-01.svg'
export { default as img13 } from './maplayer_1_3_2_m-01.svg'

/* Tab 03 */
export { default as layer1_3_3_1_4 } from './maplayer_1_3_3_oost_centrum-01.svg'
export { default as layer1_3_3_1_2 } from './maplayer_1_3_3_oost_proefdraaiplaats-01.svg'
export { default as layer1_3_3_1_3 } from './maplayer_1_3_3_oost_compenseerplates-01.svg'
export { default as layer1_3_3_4_1 } from './maplayer_1_3_3_centrum_oost-01.svg'
export { default as layer1_3_3_4_3 } from './maplayer_1_3_3_centrum_compenseerplates-01.svg'
export { default as layer1_3_3_4_2 } from './maplayer_1_3_3_centrum_proefdraaiplaats-01.svg'
export { default as layer1_3_3_3_4 } from './maplayer_1_3_3_compenseerplates_centrum-01.svg'
export { default as layer1_3_3_3_1 } from './maplayer_1_3_3_compenseerplates_oost-01.svg'
export { default as layer1_3_3_2_4 } from './maplayer_1_3_3_proefdraaiplaats_centrum-01.svg'
export { default as layer1_3_3_2_1 } from './maplayer_1_3_3_proefdraaiplaats_oost-01.svg'

/* Tab 04 */
//export { default as img23 } from './maplayer_1_3_4_1-01.svg'
//export { default as img24 } from './maplayer_1_3_4_2-01.svg'
//export { default as img25 } from './maplayer_1_3_4_3-01.svg'
//export { default as img26 } from './maplayer_1_3_4_all-01.svg'
export { default as img27 } from './maplayer_1_3_4_overzicht-01.svg'


/* Tab 05 */
export { default as img28 } from './maplayer_1_3_5_1-01.svg'
export { default as img29 } from './maplayer_1_3_5_2-01.svg'
export { default as img30 } from './maplayer_1_3_5_3-01.svg'

export { default as directionmarkerLeft } from './directionmarker-left.svg'
export { default as directionmarkerRight } from './directionmarker-right.svg'



// WEBPACK FOOTER //
// ./src/content/chapters/01/03/assets/index.js